import * as React from 'react';
import { PromoVideo } from './PromoVideo';
import { WrappedMessage } from 'utils';
import { MessageDescriptor } from 'react-intl';

interface Props {
    class: string;
    videoId: string;
    videoImageUrl: string;
    videoImageTitle: MessageDescriptor;
    heading: MessageDescriptor;
    description: MessageDescriptor;
}

export const VideoBanner = (props: Props) => {
    return (
        <div id='promo-video' className={props.class}>
            <div className='video'>
                <PromoVideo
                    videoId={props.videoId}
                    videoImageUrl={props.videoImageUrl}
                    videoImageTitle={props.videoImageTitle}
                />
            </div>
            <div className='video-description'>
                <h2><WrappedMessage message={props.heading}/></h2>
                <div className='heading-underline'></div>
                <p>
                    <WrappedMessage message={props.description}
                                    values={{linebreak: <br></br>}}/>
                </p>
            </div>
        </div>
    );
};
